<template>
    <div v-resize="setContentHeight">
        <!-- Top View -->
        <v-card style="border-radius: 0px" color="primary" class="pr-1"
            :height="visitBranchMenus ? '140px' : '104px'">

            <!-- Toolbar -->
            <v-toolbar id="newBookingToolbar" dark elevation="0" color="primary" style="border-bottom-right-radius: 5px; border-bottom-left-radius: 5px">
                <img img aria-label="NLB Logo" style="height: 48px; widthx: 24px" class="mr-3" 
                    :src="`${this.iconPath}nlb-logo-white.png`"/>

                <v-toolbar-title>Seat Availability</v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- <v-btn aria-label="Show help" @click="$router.push({ name: 'Help' }, () => {})" icon>
                    <v-icon>mdi-help-circle-outline</v-icon>
                </v-btn>

                <v-btn icon>
                    <LoginIcon />
                </v-btn> -->
            </v-toolbar>
        </v-card>

        <div ref="homeScrollable" class="scrollable" 
            :style="visitBranchMenus ? 'margin-top: -36px !important' : 'margin-top: -45px !important'"
        >        
            <!-- Search form not in use -->
            <div v-if="visitBranchMenus" v-show="!showSeatBookingSearchForm">
                <VisitBookingSearchForm ref="visitBookingSearchForm" />
            </div>

            <v-card class="mx-2 px-5 pt-4 pb-3 mb-2" style="border-radius: 8px"
                v-if="(!visitBranchMenus || showSeatBookingSearchForm)">

                <div>
                    <div class="label">
                        <span>
                            <v-icon color="green" slot="prepend-inner">mdi-seat</v-icon>
                            Available
                        </span>
                        <span>
                            <v-icon color="red" slot="prepend-inner">mdi-cancel</v-icon>
                            Not Available
                        </span>
                    </div>
                    <div style="margin-top:.5rem">
                        <UpdateTimer @times-up="searchSeatAvailability(branchCode, areaId)" class="py-3" />
                    </div>    
                </div>

                <!-- Library -->
                <div>
                    <span class="label">Library</span>

                    <v-text-field aria-label="Select library"
                        :value="branch" readonly>
                        <v-icon slot="prepend-inner">mdi-library</v-icon>
                    </v-text-field>
                </div>

                <!-- Accordion :index="i+1" -->
                <div v-if="areas" class="accordion">
                    <Accordion v-for="(area,i) in areas" 
                        :areas="[area]"
                        :index="i+1"
                        :key="i"
                        :open="area.open"
                        :displaySlots="displaySlots"
                        @toggleOpen="toggleOpen"
                    />
                </div>
                <div v-else>
                    <span>Unable to retrieve records.</span>
                </div>

            </v-card>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations, mapState } from 'vuex';
    import apiHelper from "@/helpers/apiHelper";
    import LoginIcon from "@/components/LoginIcon";
    import Accordion from "@/components/Accordion";
    import UpdateTimer from "@/components/UpdateTimer";
    import businessLogic from "@/helpers/businessLogic";
    import VisitBookingSearchForm from "@/components/VisitBookingSearchForm";

    require('@/assets/styles/main.css')

    export default {
        name: "SeatsAvailability",
        components: {
            LoginIcon,
            Accordion,
            UpdateTimer,
            VisitBookingSearchForm,
        },

        props: {
            fixed: Boolean
        },

        data: () => ({           
            areas: [],          // for data after branch is searched
            branch: null,
            areaId: null,
            branchCode: null,
            currentTime: null,  // for last load/refresh time
            displaySlots: window.$settings.seatAvailabilityFixedDisplaySlotsDisplay,
        }),

        computed: {
            // Get BranchMenu from index.js 
            ...mapState(["searchResults"]),
            ...mapGetters(["seatBranchMenus"]),

            selectedBranch() { 
                return this.inputPopupSelectBranch.selectedItem; 
            },
            
            selectedArea() { 
                return this.inputPopupSelectArea.selectedItem; 
            },
        },

        methods: {
            ...mapMutations([
                "updateSearchResults",
            ]),

            setContentHeight() {
                if (this.$refs.homeScrollable) {
                    const heights = this.heights();                  
                    const contentHeight = this.Accordion
                    ? heights.screen - heights.toolbarWithButtons - heights.bottombar - heights.noticeBarHeight
                    : heights.screen - heights.toolbar - heights.bottombar - heights.noticeBarHeight;

                    this.$refs.homeScrollable.style.height = contentHeight + "px";
                }
            },

            async searchSeatAvailability(branchCode, areaId) {
                const searchResponse = await apiHelper.searchSeatAvailability(branchCode, areaId);

                if (searchResponse === window.$msg.reloginRequired) {
                    // console.log("login required");
                    businessLogic.im8Logout();
                    return;
                }

                if (searchResponse && 
                    searchResponse.data && 
                    searchResponse.data.areas &&
                    searchResponse.data.areas.length) {
                        this.updateSearchResults(searchResponse.data);

                        if (searchResponse.data.found) 
                        {
                            this.branch = searchResponse.data.branchName;
                            this.areas  = searchResponse.data.areas;
                        }
                }
                else {
                    // Api response did not retrieve anything, display error warning
                    // this.updateResult({
                    //     show: true,
                    //     success: false,
                    //     title: window.$msg.noResultsFoundTitle,
                    //     message: window.$msg.noResultsFoundMsg,
                    // });

                    this.$router.push({ name: 'SeatsAvailabilities' }, () => {});
                }
            },
            // Accordion toggleOpen method
            toggleOpen(index) {
                this.areas = this.areas.map((area, i) => {
                    if (index === i + 1) {
                        area.open = !area.open;
                    }
                    else {
                        area.open = false;
                    }         
                    return area;
                });
            },
        },

        beforeRouteEnter(to, from, next) {                       
            next(vm => {
                vm.branchCode   = to.params.branchCode;
                vm.areaId       = to.params.areaId;
                vm.searchSeatAvailability(vm.branchCode, vm.areaId);
            })
        },
    };
</script>

<style scoped> 
    .accordion {
        width: 100%;
        padding-bottom: 120px;
    }

    .accordion-item {
        border: 1px solid #ccc;
        margin-bottom: 5px;
    }

    .accordion-title {
        background-color: #f4f4f4;
        padding: 10px;
        cursor: pointer;
    }

    .accordion-title.active {
        background-color: #e0e0e0;
    }

    .accordion-content {
        padding: 10px;
    }
</style>